import { render, staticRenderFns } from "./MoneyUsering.vue?vue&type=template&id=6dcec09a"
import script from "./MoneyUsering.vue?vue&type=script&lang=js"
export * from "./MoneyUsering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports